/**
 * Tag Filter Module
 * Filters blog posts by tag on the blog index page
 */

export function initTagFilter() {
  const filterButtons = document.querySelectorAll('.tag-filter-btn');
  const postCards = document.querySelectorAll('.post-card');
  const noPostsMessage = document.getElementById('no-posts-message');

  if (!filterButtons.length || !postCards.length) return;

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const selectedTag = button.getAttribute('data-tag');

      // Update active button
      filterButtons.forEach((btn) => btn.classList.remove('active'));
      button.classList.add('active');

      // Filter posts
      let visibleCount = 0;
      postCards.forEach((card) => {
        const cardTags = card.getAttribute('data-tags');

        if (selectedTag === 'all' || cardTags.includes(selectedTag)) {
          card.style.display = '';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      // Show/hide no posts message
      if (visibleCount === 0) {
        noPostsMessage.classList.remove('hidden');
      } else {
        noPostsMessage.classList.add('hidden');
      }
    });
  });
}
